// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../css/Theme.bs.js";
import * as React from "react";
import * as NavItem from "./NavItem.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Router from "next/router";
import * as LogoutButton from "./LogoutButton.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.display("none"),
      tl: {
        hd: BsCss.media("(min-width: 1288px)", {
              hd: BsCss.width(BsCss.px(320)),
              tl: {
                hd: BsCss.minWidth(BsCss.px(220)),
                tl: {
                  hd: BsCss.display("flex"),
                  tl: {
                    hd: BsCss.flexDirection("column"),
                    tl: {
                      hd: BsCss.paddingRight(BsCss.px(30)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var titleContainer = Curry._1(BsCss.style, {
      hd: BsCss.marginTop(BsCss.rem(1.875)),
      tl: {
        hd: BsCss.marginBottom(BsCss.rem(1.5)),
        tl: /* [] */0
      }
    });

var h1 = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(1.5)),
      tl: {
        hd: BsCss.lineHeight(BsCss.rem(1.75)),
        tl: /* [] */0
      }
    });

var h2 = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.rem(1.125)),
      tl: {
        hd: BsCss.lineHeight(BsCss.rem(1.5)),
        tl: {
          hd: BsCss.marginBottom(BsCss.rem(1.0)),
          tl: /* [] */0
        }
      }
    });

var hr = Curry._1(BsCss.style, {
      hd: BsCss.marginTop(BsCss.rem(1.0)),
      tl: {
        hd: BsCss.borderTopWidth(BsCss.px(1)),
        tl: {
          hd: BsCss.borderColor(Theme.Color.lightGrey),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  container: container,
  titleContainer: titleContainer,
  h1: h1,
  h2: h2,
  hr: hr
};

var menuItems = [
  {
    title: "My orders",
    icon: [
      "fas",
      "gift"
    ],
    route: "/orders"
  },
  {
    title: "My reminders",
    icon: [
      "fas",
      "calendar-star"
    ],
    route: "/reminders"
  },
  {
    title: "My details",
    icon: [
      "far",
      "user"
    ],
    route: "/my-details"
  }
];

var make = React.memo(function (props) {
      var router = Router.useRouter();
      var isHighlighted = React.useCallback((function (route) {
              return router.pathname.includes(route);
            }), [router.pathname]);
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("h1", {
                                children: Util.ReactStuff.s("Hi " + props.user.firstName),
                                className: h1
                              }),
                          className: titleContainer
                        }),
                    JsxRuntime.jsx("h2", {
                          children: Util.ReactStuff.s("My account"),
                          className: h2
                        }),
                    JsxRuntime.jsx("nav", {
                          children: JsxRuntime.jsx("ul", {
                                children: Belt_Array.map(menuItems, (function (item) {
                                        return JsxRuntime.jsx(NavItem.make, {
                                                    title: item.title,
                                                    icon: item.icon,
                                                    route: item.route,
                                                    isHighlighted: Curry._1(isHighlighted, item.route)
                                                  }, item.route);
                                      }))
                              }),
                          "aria-label": "My account navigation"
                        }),
                    JsxRuntime.jsx("hr", {
                          className: hr
                        }),
                    JsxRuntime.jsx(LogoutButton.make, {})
                  ],
                  className: container
                });
    });

export {
  Styles ,
  menuItems ,
  make ,
}
/* container Not a pure module */
